import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { TableViewService } from '../../services/table-view.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-table-view-placeholder-content',
	styleUrls: ['./table-view-placeholder-content.component.scss'],
	templateUrl: './table-view-placeholder-content.component.html',
	standalone: false,
})
export class TableViewPlaceholderContentComponent {
	tableViewService = inject<TableViewService<any, any>>(TableViewService);

	@Input() itemName: string;
	@Input() showResetButton = true;

	resetFilters(): void {
		this.tableViewService.resetAllFilters();
	}
}
